<script setup>
import { computed, ref } from 'vue'
import DropDownMenu from '@/components/Atoms/DropDownMenu.vue'
import DropDownMenuItem from '@/components/Atoms/DropDownMenuItem.vue'
import IconBase from '@/components/icon/IconBase.vue'
import IconChevronDown from '@/components/icon/IconChevronDown.vue'

/** Flow picker for the Automation editor: label, placeholder, inline error. */
const props = defineProps({
	modelValue: { type: String, default: null },
	flows: { type: Array, default: () => [] },
	label: { type: String, default: '' },
	placeholder: { type: String, default: 'Select a scene' },
	error: { type: String, default: '' },
	testid: { type: String, default: undefined },
	/** DropDownMenu placement; "top-left" opens upward for the last field in a scroll body. */
	position: { type: String, default: 'left' },
})
const emit = defineEmits(['update:modelValue'])

const menu = ref(null)
const selected = computed(() => props.flows.find((flow) => String(flow._id) === String(props.modelValue)) || null)

const choose = (flow) => {
	emit('update:modelValue', flow._id)
	menu.value?.hide()
}
</script>

<template>
	<div class="min-w-0">
		<label v-if="label" class="mb-2 block text-tiny font-medium text-surface-text-1">{{ label }}</label>
		<DropDownMenu ref="menu" type="flat" size="md" fullWidth :position="position" :data-testid="testid" :aria-label="label || placeholder">
			<template #toggle-button>
				<span class="truncate" :class="selected ? 'text-surface-text-2' : 'text-surface-6'">{{ selected ? selected.name : placeholder }}</span>
				<icon-base class="ml-auto shrink-0 text-surface-8"><icon-chevron-down /></icon-base>
			</template>
			<template #menu-items>
				<DropDownMenuItem v-if="!flows.length" disabled>
					<span class="ml-2 text-surface-8">No scenes yet</span>
				</DropDownMenuItem>
				<DropDownMenuItem v-for="flow in flows" :key="flow._id" @click="choose(flow)">
					<span class="ml-2 truncate" :class="String(flow._id) === String(modelValue) ? 'text-white' : ''">{{ flow.name }}</span>
				</DropDownMenuItem>
			</template>
		</DropDownMenu>
		<p v-if="error" class="mt-1 text-xs text-error">{{ error }}</p>
	</div>
</template>
